import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment-timezone';

import type { LiveReaderCheckOutcome, LiveReaderRefusal } from '../live-reader-refusal';


@Component({
  selector: 'app-live-reader-refusal-alert',
  templateUrl: './live-reader-refusal-alert.component.html',
})
export class LiveReaderRefusalAlertComponent {
  @Input() refusal: LiveReaderRefusal;
  @Input() alertClass = 'alert-danger';
  @Output() checked = new EventEmitter<LiveReaderCheckOutcome>();

  public async handleCheckAgain() {
    if (this.refusal.checking) { return; }
    this.refusal.checking = true;

    let outcome: LiveReaderCheckOutcome;
    try {
      outcome = await this.refusal.checkAgain();
    } catch {
      outcome = 'other';
    } finally {
      this.refusal.checking = false;
    }

    if (outcome === 'live') {
      this.refusal.lastCheckAt = new Date();
    }
    this.checked.emit(outcome);
  }

  // Seconds, so two checks in the same minute visibly differ.
  public lastCheckTimeDisplay(): string {
    return moment(this.refusal.lastCheckAt).format('LTS');
  }
}
